import React from "react";
import { BsCart2 } from "react-icons/bs";
import { NavLink } from "react-router-dom";

interface FloatingCartButtonProps {
  itemCount?: number;
}

const FloatingCartButton: React.FC<FloatingCartButtonProps> = ({ itemCount = 0 }) => {
  if (itemCount === 0) return null;

  return (
    <NavLink to="/panier" className="floating-cart-btn">
      <span className="floating-cart-btn__icon">
        <BsCart2 />
      </span>
      <span className="floating-cart-btn__label">Voir le panier</span>
      <span className="floating-cart-btn__badge">{itemCount}</span>
    </NavLink>
  );
};

export default FloatingCartButton;